import { useId, useMemo } from 'react';
import '../../css/illustration.css';

/**
 * Dessin SVG inséré dans la page (pas en <img>) pour prendre la couleur de la thématique :
 * --theme-main = `color`, contours / détails / papier en sont déduits (css/illustration.css).
 * Les SVG viennent de docs/img/illustrations-* (import `?raw`) : titre retiré (décoratif), identifiants
 * et classes de leur <style> suffixés pour ne pas déborder sur la page ni entre deux dessins.
 */
function scoper(svg, uid) {
    return svg
        .replace(/<title[^>]*>[\s\S]*?<\/title>/g, '')
        .replace(/\s(role|aria-labelledby)="[^"]*"/g, '')
        // Valeurs par défaut posées sur `svg` : elles écraseraient la couleur héritée.
        .replace(/(^|[\s}])svg\s*\{[^}]*\}/g, '$1')
        .replace(/<style>([\s\S]*?)<\/style>/g, (_, css) => `<style>${css.replace(/\.([a-z][\w-]*)/g, `.${uid}-$1`)}</style>`)
        .replace(/class="([^"]*)"/g, (_, cls) => `class="${cls.split(/\s+/).filter(Boolean).map(c => `${uid}-${c}`).join(' ')}"`)
        .replace(/id="([^"]+)"/g, `id="$1-${uid}"`)
        .replace(/url\(#([^)]+)\)/g, `url(#$1-${uid})`)
        .replace(/href="#([^"]+)"/g, `href="#$1-${uid}"`);
}

export default function Illustration({ svg, color, className = '' }) {
    const uid = 'il' + useId().replace(/[^a-zA-Z0-9]/g, '');
    const html = useMemo(() => scoper(svg, uid), [svg, uid]);
    return (
        <span className={`illu ${className}`} style={color ? { '--theme-main': color } : undefined}
            aria-hidden="true" dangerouslySetInnerHTML={{ __html: html }} />
    );
}
